export const GetDataSuccess = "GetDataSuccess";
export const GetDataStarted = "GetDataStarted";
export const GetDataFailure = "GetDataFailure";



